import React, { createContext, useContext, useMemo } from 'react';
import { useAppTheme, getStoredTheme } from './theme';

/**
 * Tema de la app disponible en cualquier pantalla.
 *
 * Lo monta AppLayout una sola vez (una sola escritura de `html[data-theme]`) y
 * lo consumen el selector del header y el de Mi cuenta ▸ Preferencias, para que
 * ambos muestren SIEMPRE el mismo modo.
 */

const ThemeCtx = createContext({ mode: 'auto', setMode: () => {} });

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useAppTheme();
  const value = useMemo(() => ({ mode, setMode }), [mode, setMode]);
  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
};

/**
 * `{ mode, setMode }`. Fuera del proveedor (una pantalla suelta, sin shell)
 * devuelve el modo guardado y un setter inerte, para que nada reviente.
 */
export const useTheme = () => {
  const ctx = useContext(ThemeCtx);
  return ctx || { mode: getStoredTheme(), setMode: () => {} };
};

export default ThemeCtx;
